import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const NotifContext = createContext();

export function NotifProvider({ children }) {
  const [notifs, setNotifs] = useState([]);

  const load = React.useCallback(() => {
    // Only attempt if logged in (token present) -- avoids noisy 401s on the login page
    if (!api.getToken()) return;
    api.notifications.list()
      .then(rows => setNotifs(rows.map(n => ({
        id: n.id, text: n.message, time: new Date(n.created_at).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}),
        read: n.read, type: n.type,
      }))))
      .catch(() => {});
  }, []);

  // Poll every 5s so notifications pushed from anywhere show up live
  useEffect(() => {
    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, [load]);

  const markRead = (id) => {
    setNotifs(prev => prev.map(x => x.id===id ? {...x,read:true} : x));
    api.notifications.markRead(id).catch(() => {});
  };
  const markAll = () => {
    setNotifs(prev => prev.map(x => ({...x,read:true})));
    api.notifications.markAllRead().catch(() => {});
  };
  const unread = notifs.filter(n => !n.read).length;

  return <NotifContext.Provider value={{ notifs, markRead, markAll, unread }}>{children}</NotifContext.Provider>;
}

export const useNotif = () => useContext(NotifContext);
